import React from 'react';

import dayjs, { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useTranslation } from 'react-i18next';

import { ActionsWrapper, GameTableItem } from '@pkg/components/Sections/Admin/Fantasy/GameList/styles';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/Button/types';
import { Colors } from '@pkg/components/Sections/Profile/Buttons/ButtonBase';
import { DepLinkButton } from '@pkg/components/deprecated';
import { useAppDispatch, useDeleteCompetition } from '@pkg/hooks';

import { type Competition } from '@app/client/common/structs';
import { addNotification } from '@app/store/actions/notification';

extend(utc);

interface Props {
    gameData: Competition;
}
export const GameRowActions = ({ gameData }: Props) => {
    const { t } = useTranslation('admin_fantasy');
    const { mutate: deleteGame } = useDeleteCompetition();
    const dispatch = useAppDispatch();

    function handleDeleteActiveGame() {
        const confirmActiveDelete = confirm(t('edit_delete_warning'));
        if (confirmActiveDelete) {
            deleteGame(gameData.id, {
                onSuccess(r) {
                    if (r.ok) {
                        dispatch(
                            addNotification({
                                message: `Successfully deleted ${r.value.name}.`,
                            }),
                        );
                    }
                },
            });
        }
    }

    function handleDelete() {
        const confirmDelete = confirm(t('edit_delete_confirmation', { name: gameData.name }));
        if (confirmDelete) {
            const now = dayjs().utc();
            const gameInProgress =
                now.isAfter(dayjs(gameData.submission_ends_at)) && now.isBefore(dayjs(gameData.ends_at));
            if (gameInProgress) {
                handleDeleteActiveGame();
                return;
            } else {
                deleteGame(gameData.id);
            }
        }
    }
    return (
        <GameTableItem>
            <ActionsWrapper>
                <DepLinkButton to={`/fantasy/${gameData.slug}`} size="x-small" target="_blank">
                    {t('list_action_view')}
                </DepLinkButton>
                {/*  // TODO - we can't actually delete games right now - BE needs to be merged */}
                <Button color={Colors.transparent} onClick={handleDelete} size={Sizes.xsmall}>
                    {t('list_action_delete')}
                </Button>
            </ActionsWrapper>
        </GameTableItem>
    );
};
